import axios from "axios";

const token = localStorage.getItem("token");
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const tweetApiUrl =
  process.env.REACT_APP_TWEET_API_URL || "https://api.blogslicer.com/api/tweet";

const api = axios.create({
  baseURL: tweetApiUrl,
  headers: headers,
});

// const api = axios.create({
//   baseURL: "http://localhost:8081",
//   headers: headers,
// });

const createTweet = (post) => {
  const token = localStorage.getItem("token");
  return api.post("/createtweet", post, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getTweets = () => {
  const token = localStorage.getItem("token");
  return api.get("/getweets", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getSavedTweets = (queryParams) => {
  const token = localStorage.getItem("token");
  return api.get(`/getsavedtweets?${queryParams}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const updateTweet = (tweetId, text) => {
  const token = localStorage.getItem("token");
  return api.put(
    `/updatetweet/${tweetId}`,
    { text },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// const createTweet = (post) => api.post("/createtweet", post);
// const getTweets = () => api.get("/getweets");
// const getSavedTweets = (queryParams) =>
//   api.get(`/getsavedtweets?${queryParams}`);

export { createTweet, getTweets, getSavedTweets, updateTweet };
